// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
 * Global driver chat: modal (tabs, conversation list, thread) plus toast notifications.
 * Rendered through a portal into body, hence literal colours - it lives outside the app themes.
 * ========================================================================== */

.vs-chat {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(30, 42, 50, 0.35);
    z-index: 1400;
}

.vs-chat__box {
    display: flex;
    flex-direction: column;
    width: min(460px, calc(100vw - 32px));
    height: min(640px, calc(100vh - 48px));
    background: #fff;
    border: 1px solid #D3D8DE;
    border-radius: 10px;
    box-shadow: 0 8px 28px rgba(30, 42, 50, 0.3);
    font-family: 'Inter', 'Segoe UI', Roboto, sans-serif;
    overflow: hidden;
}

/* ---- Header ---- */
.vs-chat__head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    border-bottom: 1px solid #E3E6EA;
}

.vs-chat__title {
    flex: 1;
    font-size: 14px;
    font-weight: 700;
    color: #2A3439;
}

.vs-chat__back,
.vs-chat__close {
    border: none;
    background: none;
    line-height: 1;
    color: #66717A;
    cursor: pointer;
}

.vs-chat__back {
    font-size: 20px;
}

.vs-chat__close {
    font-size: 22px;
}

.vs-chat__back:hover,
.vs-chat__close:hover {
    color: #2A3439;
}

.vs-chat__notify {
    border: none;
    background: none;
    line-height: 1;
    font-size: 16px;
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 4px;
}

.vs-chat__notify:hover {
    background: #F0F2F4;
}

.vs-chat__notify--off {
    opacity: 0.6;
}

/* ---- Tabs ---- */
.vs-chat__tabs {
    display: flex;
    border-bottom: 1px solid #E3E6EA;
}

.vs-chat__tab {
    flex: 1;
    padding: 9px 8px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    font-family: inherit;
    font-size: 13px;
    font-weight: 600;
    color: #66717A;
    cursor: pointer;
}

.vs-chat__tab:hover {
    background: #F4F6F8;
}

.vs-chat__tab--active {
    color: #2A3439;
    border-bottom-color: #5477A6;
}

/* ---- Conversation list ---- */
.vs-chat__panel {
    flex: 1;
    overflow-y: auto;
    background: #fff;
}

.vs-chat__group {
    border-bottom: 1px solid #F1F4F6;
}

.vs-chat__groupname {
    padding: 7px 14px;
    background: #F4F6F8;
    font-size: 12px;
    font-weight: 700;
    color: #46555E;
}

.vs-chat__item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 14px;
    cursor: pointer;
    border-bottom: 1px solid #F6F8F9;
}

.vs-chat__item:hover {
    background: #F4F6F8;
}

.vs-chat__itembody {
    flex: 1;
    min-width: 0;
}

.vs-chat__name {
    font-size: 13px;
    font-weight: 600;
    color: #2A3439;
}

.vs-chat__plate {
    font-size: 11px;
    color: #66717A;
}

.vs-chat__preview {
    margin-top: 2px;
    font-size: 11px;
    color: #9AA6AF;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.vs-chat__badge {
    flex: 0 0 auto;
    min-width: 20px;
    padding: 2px 6px;
    background: #B85C5C;
    border-radius: 10px;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    text-align: center;
}

/* ---- Thread ---- */
.vs-chat__thread {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}

.vs-chat__sub {
    padding: 6px 14px;
    border-bottom: 1px solid #E3E6EA;
    font-size: 12px;
    color: #66717A;
}

.vs-chat__list {
    flex: 1;
    overflow-y: auto;
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #F4F6F8;
}

/* Empty state: margin auto centres it inside the flex list, padding handles the block panel */
.vs-chat__empty {
    margin: auto;
    padding: 28px 16px;
    color: #9AA6AF;
    font-size: 13px;
    text-align: center;
}

.vs-chat__msg {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 80%;
}

.vs-chat__msg--own {
    align-self: flex-end;
    align-items: flex-end;
}

.vs-chat__bubble {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    padding: 7px 11px;
    background: #fff;
    border: 1px solid #E3E6EA;
    border-left: 3px solid #E3E6EA;
    border-radius: 10px;
    font-size: 13px;
    color: #2A3439;
    white-space: pre-wrap;
    word-break: break-word;
}

/* Colour coding per message type (as in the legacy driver_chat.vm) */
.vs-chat__bubble--warn {
    background: #FFF3E0;
    border-color: #F0D2A8;
    border-left-color: #E8A13C;
}

.vs-chat__bubble--danger {
    background: #FFEBEE;
    border-color: #F0C3C3;
    border-left-color: #C34747;
}

.vs-chat__msg--own .vs-chat__bubble {
    background: #5477A6;
    border-color: #5477A6;
    border-left-color: #3E5D85;
    color: #fff;
}

.vs-chat__msg--own .vs-chat__bubble--warn {
    background: #B9822F;
    border-color: #B9822F;
    border-left-color: #8E6222;
}

.vs-chat__msg--own .vs-chat__bubble--danger {
    background: #B85C5C;
    border-color: #B85C5C;
    border-left-color: #8E4444;
}

.vs-chat__type {
    flex: 0 0 auto;
    font-size: 13px;
    line-height: 1.3;
}

/* Message text next to the type icon: wraps long words instead of stretching the bubble */
.vs-chat__text {
    flex: 1 1 auto;
    min-width: 0;
    line-height: 1.35;
}

.vs-chat__meta {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 2px;
    font-size: 10px;
    color: #9AA6AF;
}

/* Delivery ticks: one for SENT, two for DELIVERED, two in blue for READ */
.vs-chat__ticks {
    font-weight: 700;
    color: #9AA6AF;
}

.vs-chat__ticks--read {
    color: #2196F3;
}

/* ---- Composer: the type select stays small and unobtrusive, then the field and the button ---- */
.vs-chat__input {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-areas:
        "field  field"
        "type   send";
    align-items: end;
    gap: 6px 8px;
    padding: 10px 12px;
    border-top: 1px solid #E3E6EA;
}

/* Message type is a secondary control: no border or background, small grey text */
.vs-chat__typeselect {
    grid-area: type;
    justify-self: start;
    max-width: 190px;
    padding: 2px 18px 2px 4px;
    background: transparent;
    border: none;
    font-family: inherit;
    font-size: 11px;
    color: #8B959D;
    cursor: pointer;
    appearance: none;
    background-image: linear-gradient(45deg, transparent 50%, #A9B2B9 50%),
                      linear-gradient(135deg, #A9B2B9 50%, transparent 50%);
    background-position: right 7px center, right 3px center;
    background-size: 4px 4px, 4px 4px;
    background-repeat: no-repeat;
}

.vs-chat__typeselect:hover {
    color: #46555E;
}

.vs-chat__field {
    grid-area: field;
    resize: none;
    padding: 8px 10px;
    border: 1px solid #D3D8DE;
    border-radius: 6px;
    font-family: inherit;
    font-size: 13px;
    color: #2A3439;
}

.vs-chat__field:focus,
.vs-chat__typeselect:focus {
    outline: none;
    border-color: #5477A6;
}

.vs-chat__send {
    grid-area: send;
    align-self: end;
    padding: 8px 14px;
    background: #5477A6;
    border: 1px solid #5477A6;
    border-radius: 6px;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}

.vs-chat__send:disabled {
    opacity: 0.55;
    cursor: default;
}

.vs-chat__send:hover:not(:disabled) {
    background: #47678F;
    border-color: #47678F;
}

/* ============================================================================
 * Toast notifications for new messages
 * ========================================================================== */
.vs-chat-toasts {
    position: fixed;
    right: 16px;
    bottom: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    z-index: 1500;
    font-family: 'Inter', 'Segoe UI', Roboto, sans-serif;
}

.vs-chat-toast {
    width: 300px;
    padding: 9px 12px;
    background: #fff;
    border: 1px solid #D3D8DE;
    border-left: 4px solid #5477A6;
    border-radius: 8px;
    box-shadow: 0 6px 18px rgba(30, 42, 50, 0.25);
    cursor: pointer;
}

.vs-chat-toast:hover {
    background: #F8FAFB;
}

.vs-chat-toast--warn {
    border-left-color: #E8A13C;
}

.vs-chat-toast--danger {
    border-left-color: #C34747;
}

.vs-chat-toast__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.vs-chat-toast__route {
    font-size: 12px;
    font-weight: 700;
    color: #2A3439;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.vs-chat-toast__close {
    border: none;
    background: none;
    font-size: 16px;
    line-height: 1;
    color: #9AA6AF;
    cursor: pointer;
}

.vs-chat-toast__close:hover {
    color: #2A3439;
}

.vs-chat-toast__body {
    margin-top: 3px;
    font-size: 12px;
    color: #66717A;
}

/* Друга дія тоста: відкрити стадіон саме на цьому маршруті. Навмисно стримана (текстова, не
 * контрастна кнопка) — головна дія тоста лишається «клік по тілу відкриває листування». */
.vs-chat-toast__action {
    margin-top: 6px;
    padding: 3px 8px;
    border: 1px solid #C5CDD4;
    border-radius: 5px;
    background: none;
    font: inherit;
    font-size: 11.5px;
    color: #405E86;
    cursor: pointer;
}

.vs-chat-toast__action:hover {
    background: #EEF3F9;
    border-color: #9FB4CE;
}`, "",{"version":3,"sources":["webpack://./src/containers/chat/chat.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qCAAqC;IACrC,sCAAsC;IACtC,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,4CAA4C;IAC5C,oDAAoD;IACpD,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,OAAO;IACP,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA,gCAAgC;AAChC;IACI,OAAO;IACP,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA,8FAA8F;AAC9F;IACI,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA,qEAAqE;AACrE;IACI,mBAAmB;IACnB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,0FAA0F;AAC1F;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA,0EAA0E;AAC1E;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,mGAAmG;AACnG;IACI,aAAa;IACb,+BAA+B;IAC/B;;qBAEiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA,kFAAkF;AAClF;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB;2EACuE;IACvE,uDAAuD;IACvD,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;+EAE+E;AAC/E;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,aAAa;IACb,oDAAoD;AACxD;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,6CAA6C;IAC7C,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;0FAC0F;AAC1F;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB","sourcesContent":["/* ============================================================================\n * Global driver chat: modal (tabs, conversation list, thread) plus toast notifications.\n * Rendered through a portal into body, hence literal colours - it lives outside the app themes.\n * ========================================================================== */\n\n.vs-chat {\n    position: fixed;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(30, 42, 50, 0.35);\n    z-index: 1400;\n}\n\n.vs-chat__box {\n    display: flex;\n    flex-direction: column;\n    width: min(460px, calc(100vw - 32px));\n    height: min(640px, calc(100vh - 48px));\n    background: #fff;\n    border: 1px solid #D3D8DE;\n    border-radius: 10px;\n    box-shadow: 0 8px 28px rgba(30, 42, 50, 0.3);\n    font-family: 'Inter', 'Segoe UI', Roboto, sans-serif;\n    overflow: hidden;\n}\n\n/* ---- Header ---- */\n.vs-chat__head {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 14px;\n    border-bottom: 1px solid #E3E6EA;\n}\n\n.vs-chat__title {\n    flex: 1;\n    font-size: 14px;\n    font-weight: 700;\n    color: #2A3439;\n}\n\n.vs-chat__back,\n.vs-chat__close {\n    border: none;\n    background: none;\n    line-height: 1;\n    color: #66717A;\n    cursor: pointer;\n}\n\n.vs-chat__back {\n    font-size: 20px;\n}\n\n.vs-chat__close {\n    font-size: 22px;\n}\n\n.vs-chat__back:hover,\n.vs-chat__close:hover {\n    color: #2A3439;\n}\n\n.vs-chat__notify {\n    border: none;\n    background: none;\n    line-height: 1;\n    font-size: 16px;\n    cursor: pointer;\n    padding: 2px 4px;\n    border-radius: 4px;\n}\n\n.vs-chat__notify:hover {\n    background: #F0F2F4;\n}\n\n.vs-chat__notify--off {\n    opacity: 0.6;\n}\n\n/* ---- Tabs ---- */\n.vs-chat__tabs {\n    display: flex;\n    border-bottom: 1px solid #E3E6EA;\n}\n\n.vs-chat__tab {\n    flex: 1;\n    padding: 9px 8px;\n    background: none;\n    border: none;\n    border-bottom: 2px solid transparent;\n    font-family: inherit;\n    font-size: 13px;\n    font-weight: 600;\n    color: #66717A;\n    cursor: pointer;\n}\n\n.vs-chat__tab:hover {\n    background: #F4F6F8;\n}\n\n.vs-chat__tab--active {\n    color: #2A3439;\n    border-bottom-color: #5477A6;\n}\n\n/* ---- Conversation list ---- */\n.vs-chat__panel {\n    flex: 1;\n    overflow-y: auto;\n    background: #fff;\n}\n\n.vs-chat__group {\n    border-bottom: 1px solid #F1F4F6;\n}\n\n.vs-chat__groupname {\n    padding: 7px 14px;\n    background: #F4F6F8;\n    font-size: 12px;\n    font-weight: 700;\n    color: #46555E;\n}\n\n.vs-chat__item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 9px 14px;\n    cursor: pointer;\n    border-bottom: 1px solid #F6F8F9;\n}\n\n.vs-chat__item:hover {\n    background: #F4F6F8;\n}\n\n.vs-chat__itembody {\n    flex: 1;\n    min-width: 0;\n}\n\n.vs-chat__name {\n    font-size: 13px;\n    font-weight: 600;\n    color: #2A3439;\n}\n\n.vs-chat__plate {\n    font-size: 11px;\n    color: #66717A;\n}\n\n.vs-chat__preview {\n    margin-top: 2px;\n    font-size: 11px;\n    color: #9AA6AF;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.vs-chat__badge {\n    flex: 0 0 auto;\n    min-width: 20px;\n    padding: 2px 6px;\n    background: #B85C5C;\n    border-radius: 10px;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 700;\n    text-align: center;\n}\n\n/* ---- Thread ---- */\n.vs-chat__thread {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n}\n\n.vs-chat__sub {\n    padding: 6px 14px;\n    border-bottom: 1px solid #E3E6EA;\n    font-size: 12px;\n    color: #66717A;\n}\n\n.vs-chat__list {\n    flex: 1;\n    overflow-y: auto;\n    padding: 12px 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    background: #F4F6F8;\n}\n\n/* Empty state: margin auto centres it inside the flex list, padding handles the block panel */\n.vs-chat__empty {\n    margin: auto;\n    padding: 28px 16px;\n    color: #9AA6AF;\n    font-size: 13px;\n    text-align: center;\n}\n\n.vs-chat__msg {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    max-width: 80%;\n}\n\n.vs-chat__msg--own {\n    align-self: flex-end;\n    align-items: flex-end;\n}\n\n.vs-chat__bubble {\n    display: flex;\n    align-items: flex-start;\n    gap: 6px;\n    padding: 7px 11px;\n    background: #fff;\n    border: 1px solid #E3E6EA;\n    border-left: 3px solid #E3E6EA;\n    border-radius: 10px;\n    font-size: 13px;\n    color: #2A3439;\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n/* Colour coding per message type (as in the legacy driver_chat.vm) */\n.vs-chat__bubble--warn {\n    background: #FFF3E0;\n    border-color: #F0D2A8;\n    border-left-color: #E8A13C;\n}\n\n.vs-chat__bubble--danger {\n    background: #FFEBEE;\n    border-color: #F0C3C3;\n    border-left-color: #C34747;\n}\n\n.vs-chat__msg--own .vs-chat__bubble {\n    background: #5477A6;\n    border-color: #5477A6;\n    border-left-color: #3E5D85;\n    color: #fff;\n}\n\n.vs-chat__msg--own .vs-chat__bubble--warn {\n    background: #B9822F;\n    border-color: #B9822F;\n    border-left-color: #8E6222;\n}\n\n.vs-chat__msg--own .vs-chat__bubble--danger {\n    background: #B85C5C;\n    border-color: #B85C5C;\n    border-left-color: #8E4444;\n}\n\n.vs-chat__type {\n    flex: 0 0 auto;\n    font-size: 13px;\n    line-height: 1.3;\n}\n\n/* Message text next to the type icon: wraps long words instead of stretching the bubble */\n.vs-chat__text {\n    flex: 1 1 auto;\n    min-width: 0;\n    line-height: 1.35;\n}\n\n.vs-chat__meta {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-top: 2px;\n    font-size: 10px;\n    color: #9AA6AF;\n}\n\n/* Delivery ticks: one for SENT, two for DELIVERED, two in blue for READ */\n.vs-chat__ticks {\n    font-weight: 700;\n    color: #9AA6AF;\n}\n\n.vs-chat__ticks--read {\n    color: #2196F3;\n}\n\n/* ---- Composer: the type select stays small and unobtrusive, then the field and the button ---- */\n.vs-chat__input {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    grid-template-areas:\n        \"field  field\"\n        \"type   send\";\n    align-items: end;\n    gap: 6px 8px;\n    padding: 10px 12px;\n    border-top: 1px solid #E3E6EA;\n}\n\n/* Message type is a secondary control: no border or background, small grey text */\n.vs-chat__typeselect {\n    grid-area: type;\n    justify-self: start;\n    max-width: 190px;\n    padding: 2px 18px 2px 4px;\n    background: transparent;\n    border: none;\n    font-family: inherit;\n    font-size: 11px;\n    color: #8B959D;\n    cursor: pointer;\n    appearance: none;\n    background-image: linear-gradient(45deg, transparent 50%, #A9B2B9 50%),\n                      linear-gradient(135deg, #A9B2B9 50%, transparent 50%);\n    background-position: right 7px center, right 3px center;\n    background-size: 4px 4px, 4px 4px;\n    background-repeat: no-repeat;\n}\n\n.vs-chat__typeselect:hover {\n    color: #46555E;\n}\n\n.vs-chat__field {\n    grid-area: field;\n    resize: none;\n    padding: 8px 10px;\n    border: 1px solid #D3D8DE;\n    border-radius: 6px;\n    font-family: inherit;\n    font-size: 13px;\n    color: #2A3439;\n}\n\n.vs-chat__field:focus,\n.vs-chat__typeselect:focus {\n    outline: none;\n    border-color: #5477A6;\n}\n\n.vs-chat__send {\n    grid-area: send;\n    align-self: end;\n    padding: 8px 14px;\n    background: #5477A6;\n    border: 1px solid #5477A6;\n    border-radius: 6px;\n    color: #fff;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.vs-chat__send:disabled {\n    opacity: 0.55;\n    cursor: default;\n}\n\n.vs-chat__send:hover:not(:disabled) {\n    background: #47678F;\n    border-color: #47678F;\n}\n\n/* ============================================================================\n * Toast notifications for new messages\n * ========================================================================== */\n.vs-chat-toasts {\n    position: fixed;\n    right: 16px;\n    bottom: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    z-index: 1500;\n    font-family: 'Inter', 'Segoe UI', Roboto, sans-serif;\n}\n\n.vs-chat-toast {\n    width: 300px;\n    padding: 9px 12px;\n    background: #fff;\n    border: 1px solid #D3D8DE;\n    border-left: 4px solid #5477A6;\n    border-radius: 8px;\n    box-shadow: 0 6px 18px rgba(30, 42, 50, 0.25);\n    cursor: pointer;\n}\n\n.vs-chat-toast:hover {\n    background: #F8FAFB;\n}\n\n.vs-chat-toast--warn {\n    border-left-color: #E8A13C;\n}\n\n.vs-chat-toast--danger {\n    border-left-color: #C34747;\n}\n\n.vs-chat-toast__head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n}\n\n.vs-chat-toast__route {\n    font-size: 12px;\n    font-weight: 700;\n    color: #2A3439;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.vs-chat-toast__close {\n    border: none;\n    background: none;\n    font-size: 16px;\n    line-height: 1;\n    color: #9AA6AF;\n    cursor: pointer;\n}\n\n.vs-chat-toast__close:hover {\n    color: #2A3439;\n}\n\n.vs-chat-toast__body {\n    margin-top: 3px;\n    font-size: 12px;\n    color: #66717A;\n}\n\n/* Друга дія тоста: відкрити стадіон саме на цьому маршруті. Навмисно стримана (текстова, не\n * контрастна кнопка) — головна дія тоста лишається «клік по тілу відкриває листування». */\n.vs-chat-toast__action {\n    margin-top: 6px;\n    padding: 3px 8px;\n    border: 1px solid #C5CDD4;\n    border-radius: 5px;\n    background: none;\n    font: inherit;\n    font-size: 11.5px;\n    color: #405E86;\n    cursor: pointer;\n}\n\n.vs-chat-toast__action:hover {\n    background: #EEF3F9;\n    border-color: #9FB4CE;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
